import { useTranslation } from 'react-i18next';
import { useUserGeneratedContent } from '../../../../models/user-generated-contents/context';
import { LexicalBodyEditor } from '../../../../components/lexical-rich-text-editor';
import '../form.scss';

const BodyInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
    memberValidationErrors,
  } = useUserGeneratedContent();
  const { t } = useTranslation();
  const onTextChange = (body: string) => {
    updateUserGeneratedContentFormState({ body });
  };

  const showError = memberValidationErrors.body;

  return (
    <div className="ugc__editor-input-wrapper-body">
      <LexicalBodyEditor
        defaultValue={userGeneratedContent.body}
        onChange={onTextChange}
        disabled={isPersisting}
        placeholder={t('user_generated_content.field_body_placeholder')}
        errorMessage={
          showError
            ? t('user_generated_content.validation.body_or_attachment_required')
            : undefined
        }
      />
    </div>
  );
};

export default BodyInput;
